import React from 'react';
export function PrivacyPolicy() {
  return <div className="bg-white min-h-screen py-16" data-id="element-924">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-925">
        <h1 className="text-4xl font-extrabold text-warm-900 mb-2" data-id="element-926">
          Privacy Policy
        </h1>
        <p className="text-warm-500 mb-12" data-id="element-927">Last updated: March 6, 2026</p>

        <div className="prose prose-lg max-w-none text-warm-700 space-y-8" data-id="element-928">
          <section data-id="element-929">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-930">
              1. Information We Collect
            </h2>
            <p data-id="element-931">
              When you use AccessRide's services or visit our website, we may
              collect the following types of information:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-932">
              <li data-id="element-933">
                <strong data-id="element-934">Personal Information:</strong> Name, phone number, email
                address, home address, and pickup/drop-off locations provided
                when booking a ride.
              </li>
              <li data-id="element-935">
                <strong data-id="element-936">Medical Information:</strong> Type of mobility
                assistance needed, wheelchair or mobility device details, and
                any special requirements you share with us.
              </li>
              <li data-id="element-937">
                <strong data-id="element-938">Payment Information:</strong> Credit card details,
                insurance information, or Medicaid/Medicare details for billing
                purposes.
              </li>
              <li data-id="element-939">
                <strong data-id="element-940">Usage Data:</strong> Information about how you interact
                with our website, including pages visited and booking activity.
              </li>
            </ul>
          </section>

          <section data-id="element-941">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-942">
              2. How We Use Your Information
            </h2>
            <p data-id="element-943">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-944">
              <li data-id="element-945">Schedule and provide transportation services</li>
              <li data-id="element-946">Communicate with you about your bookings and account</li>
              <li data-id="element-947">Process payments and insurance claims</li>
              <li data-id="element-948">Improve our services and customer experience</li>
              <li data-id="element-949">Comply with legal and regulatory requirements</li>
              <li data-id="element-950">
                Send service-related notifications such as ride confirmations
                and reminders
              </li>
            </ul>
          </section>

          <section data-id="element-951">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-952">
              3. HIPAA Compliance
            </h2>
            <p data-id="element-953">
              As a Non-Emergency Medical Transportation (NEMT) provider,
              AccessRide is committed to protecting your health information in
              accordance with the Health Insurance Portability and
              Accountability Act (HIPAA). We implement appropriate physical,
              technical, and administrative safeguards to protect any protected
              health information (PHI) we receive.
            </p>
          </section>

          <section data-id="element-954">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-955">
              4. Information Sharing
            </h2>
            <p data-id="element-956">
              We do not sell your personal information. We may share your
              information with:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-957">
              <li data-id="element-958">
                <strong data-id="element-959">Our Drivers:</strong> Necessary trip details to provide
                your transportation service.
              </li>
              <li data-id="element-960">
                <strong data-id="element-961">Healthcare Facilities:</strong> When coordinating rides
                on behalf of a medical provider or facility.
              </li>
              <li data-id="element-962">
                <strong data-id="element-963">Insurance Providers:</strong> For billing and claims
                processing when applicable.
              </li>
              <li data-id="element-964">
                <strong data-id="element-965">Legal Authorities:</strong> When required by law or to
                protect the safety of our passengers and staff.
              </li>
            </ul>
          </section>

          <section data-id="element-966">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-967">
              5. Data Security
            </h2>
            <p data-id="element-968">
              We implement industry-standard security measures to protect your
              personal information, including encrypted data transmission,
              secure servers, and restricted access to personal data. However,
              no method of electronic transmission or storage is 100% secure,
              and we cannot guarantee absolute security.
            </p>
          </section>

          <section data-id="element-969">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-970">
              6. Your Rights
            </h2>
            <p data-id="element-971">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-972">
              <li data-id="element-973">
                Request access to the personal information we hold about you
              </li>
              <li data-id="element-974">Request correction of inaccurate information</li>
              <li data-id="element-975">
                Request deletion of your personal information, subject to legal
                obligations
              </li>
              <li data-id="element-976">Opt out of non-essential communications</li>
            </ul>
          </section>

          <section data-id="element-977">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-978">
              7. Cookies
            </h2>
            <p data-id="element-979">
              Our website may use cookies and similar technologies to improve
              your browsing experience. You can control cookie settings through
              your browser preferences.
            </p>
          </section>

          <section data-id="element-980">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-981">
              8. Contact Us
            </h2>
            <p data-id="element-982">
              If you have questions about this Privacy Policy or wish to
              exercise your rights regarding your personal data, please contact
              us:
            </p>
            <div className="mt-4 bg-warm-50 p-6 rounded-xl border border-warm-200" data-id="element-983">
              <p className="font-bold text-warm-900" data-id="element-984">
                AccessRide Transportation
              </p>
              <p data-id="element-985">123 Mobility Way, Suite 100</p>
              <p data-id="element-986">Metro City, ST 12345</p>
              <p className="mt-2" data-id="element-987">Phone: (555) 123-4567</p>
              <p data-id="element-988">Email: privacy@accessride.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>;
}